import { getFirebaseApp } from "../utils/firebase";

export default class AuthUserService {
  static async loadAuthMethods() {
    const { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signInAnonymously, signOut, signInWithCustomToken, updateProfile, getAuth } =
      await import("firebase/auth");

    return {
      signInWithEmailAndPassword,
      createUserWithEmailAndPassword,
      sendPasswordResetEmail,
      signInAnonymously,
      signOut,
      signInWithCustomToken,
      updateProfile,
      getAuth
    };
  }

  static async getAuthInstance() {
    const { getAuth } = await this.loadAuthMethods();
    const app = await getFirebaseApp();
    return getAuth(app);
  }

  static async loginWithEmail(email, password) {
    const { signInWithEmailAndPassword } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    const result = await signInWithEmailAndPassword(auth, email, password);
    this.cacheUser(result.user);
    return result.user;
  }

  static async createUserWithEmail(email, password) {
    const { createUserWithEmailAndPassword } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    const result = await createUserWithEmailAndPassword(auth, email, password);
    this.cacheUser(result.user);
    return result.user;
  }

  static async loginAnonymous() {
    const { signInAnonymously } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    const result = await signInAnonymously(auth);
    this.cacheUser(result.user);
    return result.user;
  }

  static async loginCustom(customToken) {
    const { signInWithCustomToken } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    const result = await signInWithCustomToken(auth, customToken);
    this.cacheUser(result.user);
    return result.user;
  }

  static async logOut() {
    const { signOut } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    await signOut(auth);
    localStorage.removeItem("user");
  }

  static async sendPasswordReset(email) {
    const { sendPasswordResetEmail } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    await sendPasswordResetEmail(auth, email);
  }

  static async setUserInfo(displayName) {
    const { updateProfile } = await this.loadAuthMethods();
    const auth = await this.getAuthInstance();
    if (!auth.currentUser) throw new Error("Няма логнат потребител");
    await updateProfile(auth.currentUser, { displayName });
    this.cacheUser(auth.currentUser);
  }

  static cacheUser(user) {
    const { accessToken, email, uid, refreshToken, emailVerified, displayName, isAnonymous } = user;
    const cachedUser = {
      accessToken,
      email,
      uid,
      refreshToken,
      emailVerified,
      displayName,
      isAnonymous
    };
    localStorage.setItem("user", JSON.stringify(cachedUser));
  }

  static getCachedUser() {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  }
}
